var map = {
	"./ai.svg": 9512,
	"./bootstrap.svg": 1952,
	"./c.svg": 1401,
	"./cloudflaire.svg": 6450,
	"./code.svg": 2661,
	"./django.svg": 8615,
	"./ec2.svg": 216,
	"./firebase.svg": 8289,
	"./flutter.svg": 6156,
	"./git.svg": 9350,
	"./github.svg": 8699,
	"./instagram.svg": 9230,
	"./java.svg": 854,
	"./js.svg": 3619,
	"./linkedIn.svg": 1296,
	"./meteor.svg": 2102,
	"./mongo.svg": 3546,
	"./next.svg": 8725,
	"./node.svg": 9394,
	"./php.svg": 9938,
	"./puppeteer.svg": 6564,
	"./python.svg": 7116,
	"./react.svg": 5887,
	"./s3.svg": 248,
	"./selenium.svg": 4762,
	"./sql.svg": 2034,
	"./webSocket.svg": 8711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2698;